import { useState } from "react";
import WebIcon from "@/components/common/Web_Icons";
import Input from "@/components/common/inputs/Input";
import { Switch } from "@/config/antd";

const PaymentOption = () => {
  const [autoBilling, setAutoBilling] = useState(true);
  const [paymentOption, setPaymentOption] = useState("One-Time Payment");
  const [formData, setFormData] = useState({
    paymentOption: paymentOption,
    subscription: "Veegil Base Subscription",
    price: "₦5,000",
    billingPeriod: "Monthly",
    cardNumber: "5199**************3402",
    cvv: "***",
    expiration: "2/26",
  });

  // Handler for regular input changes
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handlers for select options
  const getSubscriptionOptions = () => {
    return [
      { value: "veegil-base", label: "Veegil Base Subscription" },
      // Add more subscription options as needed
    ];
  };

  const getBillingPeriodOptions = () => {
    return [
      { value: "monthly", label: "Monthly" },
      { value: "yearly", label: "Yearly" },
      // Add more billing period options as needed
    ];
  };

  return (
    <div className="mt-4">
      <h2 className="mb-2 text-bold">Payment Options</h2>
      <p className="mb-6 text-regular text-lighterGrey">
        Manage your payment options here.
      </p>

      {/* Payment Type Cards */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div
          className={`p-4 border rounded-lg cursor-pointer ${
            paymentOption === "One-Time Payment" && "bg-secondary"
          }`}
          onClick={() => setPaymentOption("One-Time Payment")}>
          <div className="flex flex-col">
            <div className="mb-3">
              <div className="flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-sm">
                <WebIcon icon="Money" className="w-6 h-6 text-primary" />
              </div>
            </div>
            <div>
              <h3 className="mb-1 text-bold-x">One-Time Payment</h3>
              <p className="text-regular text-lighterGrey">
                We&apos;ll charge you a one-time payment fee in order to provide
                you access to our service for the period of the payment
              </p>
            </div>
          </div>
        </div>

        <div
          className={`p-4 border rounded-lg cursor-pointer ${
            paymentOption === "Recurring Payment" && "bg-secondary"
          }`}
          onClick={() => setPaymentOption("Recurring Payment")}>
          <div className="flex flex-col">
            <div className="mb-3">
              <div className="flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-sm">
                <WebIcon icon="Wallet" className="w-6 h-6 text-primary" />
              </div>
            </div>
            <div>
              <h3 className="mb-1 text-bold-x">Recurring Payment</h3>
              <p className="text-regular text-lighterGrey">
                Split the full bundle price over several monthly payments which
                is recurring based and renewable after the end of payment
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Subscription Information */}
      <div className="mt-8">
        <h3 className="mb-4 text-bold-x">Subscription Information</h3>

        <div className="grid grid-cols-1 gap-4">
          <Input
            label="SUBSCRIPTION"
            value={formData.subscription}
            onChange={(e) => handleInputChange("subscription", e.target.value)}
            type="select"
            options={getSubscriptionOptions()}
          />

          <div className="grid grid-cols-2 gap-4">
            <Input
              label="PRICE"
              value={formData.price}
              onChange={(e) => handleInputChange("price", e.target.value)}
            />
            <Input
              label="BILLING PERIOD"
              value={formData.billingPeriod}
              onChange={(e) =>
                handleInputChange("billingPeriod", e.target.value)
              }
              type="select"
              options={getBillingPeriodOptions()}
            />
          </div>
        </div>

        <div className="flex items-center my-6">
          <Switch checked={autoBilling} onChange={setAutoBilling} />
          <span className="ml-2 font-bold text-regular">Auto Billing</span>
        </div>
      </div>

      {/* Payment Information */}
      <div className="mt-8">
        <h3 className="mb-4 text-bold-x">My Payment Information</h3>

        <div className="grid grid-cols-1 gap-4">
          <Input
            label="MY CREDIT CARD NUMBER"
            value={formData.cardNumber}
            onChange={(e) => handleInputChange("cardNumber", e.target.value)}
            icon={<WebIcon icon="Wallet" />}
          />

          <div className="grid grid-cols-2 gap-4">
            <Input
              label="CVV"
              value={formData.cvv}
              onChange={(e) => handleInputChange("cvv", e.target.value)}
              type="password"
            />
            <Input
              label="EXPIRATION"
              value={formData.expiration}
              onChange={(e) => handleInputChange("expiration", e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentOption;
